import { observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";
import SearchDistributorsIssuedPaymentRequestsRequest from "../searchDistributorsIssuedPaymentRequestsRequest";

export default class DistributorPaymentRequestFilter extends SearchDistributorsIssuedPaymentRequestsRequest {
  @observable
  distributorId?: string;
}

export const DistributorPaymentRequestFilterValidationRules: EntityValidationRules<DistributorPaymentRequestFilter> = {
  distributorId: {
    required: true,
  },
};
